import auth from '@/modules/Auth';

import { thnAppsUrl } from '@/config';

function withLoginAs(url: string): string {
  const userId = auth.state.impersonatedUser?.loggedAsUserId;
  return userId ? `${url}?loginAs=${userId}` : url;
}

export const getBenchDirectRedirectUrl = () => withLoginAs(thnAppsUrl.benchdirect);

export const getPersonalizationRedirectUrl = () => withLoginAs(thnAppsUrl.personalization);

export const getDashboardsRedirectUrl = () => withLoginAs(thnAppsUrl.dashboards);

export const getDemandUrl = () => withLoginAs(thnAppsUrl.demand);

export const getAgenticAiUrl = (redirectPath?: string) => {
  let agenticAiUrl = thnAppsUrl.agenticai;

  if (redirectPath) {
    agenticAiUrl += `/${redirectPath}`;
  }

  return withLoginAs(agenticAiUrl);
};

export const redirectToAdmin = async (pid: string, redirectPath?: string) => {
  const adminUrl = import.meta.env.VUE_APP_ADMIN_URL;

  const form = document.createElement('form');
  form.method = 'POST';
  form.action = `${adminUrl}/login-sso`;

  const tokenInput = document.createElement('input');
  tokenInput.type = 'hidden';
  tokenInput.name = 'token';
  tokenInput.value = '';
  form.appendChild(tokenInput);

  const userIdInput = document.createElement('input');
  userIdInput.type = 'hidden';
  userIdInput.name = 'user_id';
  userIdInput.value = await auth.getUserId() || '';
  form.appendChild(userIdInput);

  const impersonatedUserIdField = document.createElement('input');
  impersonatedUserIdField.type = 'hidden';
  impersonatedUserIdField.name = 'impersonated_user_id';
  impersonatedUserIdField.value = auth.state.impersonatedUser?.loggedAsUserId || '';
  form.appendChild(impersonatedUserIdField);

  const impersonatedPowerLevelsInput = document.createElement('input');
  impersonatedPowerLevelsInput.type = 'hidden';
  impersonatedPowerLevelsInput.name = 'impersonated_power_levels';
  impersonatedPowerLevelsInput.value = auth.state.impersonatedUser?.loggedWithPowerLevels
    ? 'true'
    : 'false';
  form.appendChild(impersonatedPowerLevelsInput);

  if (pid) {
    const pidInput = document.createElement('input');
    pidInput.type = 'hidden';
    pidInput.name = 'pid';
    pidInput.value = pid;
    form.appendChild(pidInput);
  }

  if (redirectPath) {
    const redirectInput = document.createElement('input');
    redirectInput.type = 'hidden';
    redirectInput.name = 'redirect_path';
    redirectInput.value = redirectPath;
    form.appendChild(redirectInput);
  }

  document.body.appendChild(form);
  form.submit();
};
